import Image from "react-bootstrap/Image";
import SearchEmpty from "../../assets/images/searchEmpty.png";
import { StyledButton } from "../../styles/StyledCDButton";
import { redirectToNewTab } from "../../utils/common";
import { Wrapper } from "../../styles/norecord.styles";
import { USERDEV_BASE_URL } from "../../utils/constant";

export const NoRecordSection = () => (
  <Wrapper>
    <Image src={SearchEmpty} height={150} width={150} alt="search_empty" />
    <div className="no-record-label">No Result</div>
    <div className="no-record-sub-label">We didn&apos;t find any CDs that match those filters. </div>
    <div className="no-record-sub-label">
      Try exploring more options to find the right fit.
    </div>
    <div className="button-wrapper">
      <StyledButton
        className="explore-more-rates"
        $customColor="var(--cdv-btn-bg)"
        onClick={() => redirectToNewTab(USERDEV_BASE_URL)}
        type="button"
        role="button"
      >
        Explore More Rates
      </StyledButton>
    </div>
  </Wrapper>
);
